import React from 'react';

import { Badge, createStyles, Group, Text, clsx } from '@mantine/core';
import { IconBolt } from '@tabler/icons-react';
import { demoGymColors } from 'theme';

const useStyles = createStyles(theme => ({
  root: {
    backgroundColor: `${demoGymColors.bannerBg} !important`,
    paddingTop: `${theme.spacing.xs} !important`,
    paddingBottom: `${theme.spacing.xs} !important`,
  },
}));
const DemoGymBanner = (): JSX.Element => {
  const { classes, theme } = useStyles();

  return (
    <div className={clsx('header', classes.root)}>
      <Group spacing='xs' position='center' w='100%'>
        <Text fw={500} color='white'>
          You ‘re exploring Kilo in
        </Text>
        <Badge variant='outline' color='gray' px='xs' size='lg' bg={demoGymColors.bannerInnerComponentBg}>
          <Group align='center' spacing={2}>
            <IconBolt size={theme.fontSizes.xl} color={theme.colors.yellow[5]} />
            <Text fw={600} color='white' sx={{ textTransform: 'capitalize' }}>
              Demo Mode
            </Text>
          </Group>
        </Badge>
      </Group>
    </div>
  );
};

export default DemoGymBanner;
